<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-row style="margin: 20px 0px;">
          <b-col md="4" lg="4" sm="6">
            <div class="input-group">
              <input type="text" v-model="searchText" class="form-control" placeholder="Search">
              <div class="input-group-append">
                <button class="btn btn-secondary" @click="search()" type="button">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </b-col>
          <b-col lg="6" md="6" sm="6">
            <b-row style="width:100%;">
              <b-col lg="4" md="4" sm="6" class="highlighted">
                <!-- <label for="clients">Select Meal</label> -->
                <b-form-select style="width:100%;" v-model="selectedCategory" 
                  :plain="true"
                  :options="dropdownCat[language]">
                </b-form-select>
              </b-col>
              <b-col class="highlighted" lg="4" md="4" sm="6">
                  <b-button type="button" size="md" variant="primary" @click="selectCategory()">{{ $t('specialist.select_category') }}</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        
      </b-col>
      <b-col lg="12" style="overflow-x:scroll;">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">{{ $t("specialist.email") }}</th>
            <th scope="col">{{ $t("specialist.name") }}</th>
            <th scope="col" v-if="language == 'en'">{{ $t("specialist.category") }}</th>
            <th scope="col" v-if="language == 'iw'">{{ $t("specialist.category_iw") }}</th>
            <th scope="col">{{ $t("specialist.speciality") }}</th>
            <th scope="col">{{ $t("specialist.commission") }}</th>
            <th scope="col">{{ $t("specialist.degree") }}</th>
            <th scope="col">{{ $t("specialist.address") }}</th>
            <th scope="col">{{ $t("specialist.work") }} </th>
            <th scope="col">{{ $t("specialist.phone") }} </th>
            <th scope="col">{{ $t("specialist.info") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="specialist in specialists">
            <td scope="row">{{specialist.email}}</td>
            <td>{{specialist.first_name}} {{specialist.last_name}}</td>
            <td v-if="language == 'en'">{{specialist.category}}</td>
            <td v-if="language == 'iw'">{{specialist.category_hebrew}}</td>
            <td>{{specialist.speciality}}</td>
            <td>{{ specialist | getCommission}} </td>
            <td>{{specialist.degree}}</td>
            <td>{{specialist.address}}</td>
            <td>{{specialist.opens_at}} - {{specialist.closes_at}}</td>
            <td>{{specialist.tell_number}}</td>
            <td>
              <b-button v-if="!!specialist.description"  type="button" size="md" variant="primary"  @click="showInfo(specialist)">Info</b-button>
              <div v-if="!specialist.description">No Info</div>
            </td>
          </tr>
        </tbody>
      </table>
      </b-col>
    </b-row>
    <b-modal style="padding:1rem 6rem;" title="Specialist Info" size="xl" v-model="myModal" @ok="myModal = false">
      <b-row v-if="!!selectedSpecialist"  style="justify-content: center;">
        <b-col md="10" lg="10" sm="10" >
          <b-row  style="margin: 20px 0px;">
            <b-col md="6" lg="6" sm="6">
              <h3>{{ $t("specialist.profile") }}</h3>
            </b-col>
            <b-col md="6" lg="6" sm="6">
              <b-button type="button" class="pull-right" size="md" variant="primary" @click="openContactModal()">Contact Specialist</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" lg="2" sm="2">
              <img height="100" :src="serverUrl+selectedSpecialist.user.profile_image" alt="">
            </b-col>
            <b-col md="8" lg="8" sm="8">
              <h3>{{ $t("specialist.name") }} : {{selectedSpecialist.user.first_name}} {{selectedSpecialist.user.last_name}}</h3>
              <h5 v-if="language == 'en'">{{ $t("specialist.degree") }} : {{selectedSpecialist.degree}}, {{selectedSpecialist.category}}, {{selectedSpecialist.speciality}}</h5>
              <h5 v-if="language == 'iw'">{{ $t("specialist.degree") }} : {{selectedSpecialist.degree}}, {{selectedSpecialist.category_hebrew}}, {{selectedSpecialist.speciality}}</h5>
              <h6>{{ $t("specialist.email") }} : {{selectedSpecialist.email}},   {{ $t("specialist.phone") }} : {{selectedSpecialist.tell_number}} </h6>
              <h6>{{ $t("specialist.address") }} : {{selectedSpecialist.address}}</h6>
              <h6>{{ $t("specialist.work") }} : {{selectedSpecialist.opens_at}} - {{selectedSpecialist.closes_at}}</h6>
              <h6>{{ $t("specialist.commission") }} : {{ selectedSpecialist | getCommission}}</h6>
            </b-col>
          </b-row>

          <b-row v-if="selectedSpecialist.photos.length > 0" style="margin-top: 30px;">
            <b-col md="6" lg="6" sm="6">
              <h3>{{ $t("specialist.images") }}</h3>
            </b-col>
          </b-row>
          <b-row v-if="selectedSpecialist.photos.length > 0">
            <b-col md="3" lg="3" sm="3" style="text-align:center;" v-for="photo in selectedSpecialist.photos">
              <img height="100" :src="serverUrl+photo.path" alt="">
            </b-col>
          </b-row>

          <b-row v-if="selectedSpecialist.links.length > 0" style="margin-top: 30px;">
            <b-col md="6" lg="6" sm="6">
              <h3>{{ $t("specialist.links") }}</h3>
            </b-col>
          </b-row>
          <b-row v-if="selectedSpecialist.links.length > 0">
            <b-col md="3" lg="3" sm="3" style="text-align:center;" v-for="link in selectedSpecialist.links">
              <a :href="link.link" target="_blank">{{link.link}}</a>
            </b-col>
          </b-row>

          <b-row  v-if="!!selectedSpecialist.description" style="margin-top: 30px;">
            <b-col md="6" lg="6" sm="6">
              <h3>{{ $t("specialist.description") }}</h3>
            </b-col>
          </b-row>

          <b-row  v-if="!!selectedSpecialist.description">
            <b-col md="12" lg="12" sm="12">
            <div v-html="selectedSpecialist.description"></div>
            </b-col>
          </b-row>
          <b-row style="display: flex;">
            <label for="clients" style="margin-right: 10px;">{{ $t('client.client_refer_button') }}
              <i class="fa fa-info-circle" data-toggle="tooltip" :title="$t('client.refer_specialist')" data-original-title=""></i>
            </label>
            <b-form-select id="clients" v-model="selectedClient" @onSelect="selectChanged()" class="col-sm-5"
              :plain="true"
              :options="clients">
            </b-form-select>
            <b-button type="button" size="md" variant="primary" @click="referToSpecialist(selectedSpecialist)" style="margin-left: 10px;">{{ $t('client.client_refer_button') }}</b-button>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal style="padding:1rem 6rem;" title="Contact Specialist" size="xl" v-model="messageModal" @ok="messageModal = false">
      <b-row style="justify-content: center;">
        <b-col md="10" lg="10" sm="10" >
            <div class="card card-default">
              <div class="card-body">
                  <form @submit="$event.preventDefault()">
                    <div class="form-group">
                      <label>Message</label> 
                      <textarea v-model="message" name="content" cols="20" rows="5" class="form-control"></textarea>
                    </div>
                    <div class="form-group">
                      <b-button @click="contact()" type="submit" variant="primary">Contact</b-button>
                    </div>
                  </form>
              </div>
            </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Models from '@/store/ORM/models.js';
import SpecialistService from '@/services/specialist.service.js';
import * as constants from '../helpers/Constants.js';

var moment = require('moment');

export default {
  name: 'dashboard',
  data: function () {
    return {
      myModal: false,
      selectedSpecialist: null,
      specialists : [],
      specialistAll : [],
      categories : [],
      dropdownCat : { en : [""], iw:[""]},
      serverUrl : constants.serverUrl,
      searchText : "",
      selectedCategory:null,
      user : Models.Nutritionist.query().first(),
      selectedClient: null,
      messageModal:false,
      message:"",
    }
  },
  mounted() {
    SpecialistService.getSpceialists().then((specRes)=>{
      let specialists = specRes.data.specialists;
      this.categories = specRes.data.categories;

      specRes.data.categories.forEach((cat)=>{
        this.dropdownCat.en.push(cat.name);
        this.dropdownCat.iw.push(cat.slug);
      });

      specialists.map(el => {
        el.email = el.user.email;
        el.first_name = el.user.first_name;
        el.last_name = el.user.last_name;
        if(!!el.categories && el.categories.length > 0){
          el.category = el.categories[0].name;
          el.category_hebrew = el.categories[0].slug;
        }
      });

      this.specialists = specialists;
      this.specialistAll = specialists;
    });
  },
  methods : {
    showInfo(specialist){
      this.selectedSpecialist = specialist;
      this.myModal = true;
    },
    search(){
      this.specialists = this.specialistAll.filter((el)=>{
        if(!!el.first_name && el.first_name.indexOf(this.searchText) !== -1 ){
          return true;
        }
        if(!!el.email && el.email.indexOf(this.searchText) !== -1 ){
          return true;
        }
        if(!!el.last_name && el.last_name.indexOf(this.searchText) !== -1 ){
          return true;
        }
        if(!!el.address && el.address.indexOf(this.searchText) !== -1 ){
          return true;
        }
        return false;
      })
    },
    selectCategory(){
      if(!this.selectedCategory){
        this.specialists = this.specialistAll;
        this.search();
        return;
      }
      this.specialists = this.specialistAll.filter((el) => {
        if(this.language == 'en'){
          return el.category == this.selectedCategory;
        }else{
          return el.category_hebrew == this.selectedCategory;
        }
      });
    },

    referToSpecialist(selectedSpecialist){
      if(!this.selectedClient){
        this.$toastr.error(this.$i18n.t('client.client_not_selected'),this.$i18n.t('client.client_not_selected'));
        return;
      }
     
      var client = this.selectedClient;
      var body = {
        client_id : client.split('')[0],
        nutritionist_id: this.user.id,
        specialist_id : selectedSpecialist.id,
        nutritionist_firstname : this.user.first_name,
        nutritionist_lastname : this.user.last_name,
        client : JSON.stringify([client])
      }
      SpecialistService.referSpecialist(body).then((res)=>{
        this.referals = res.data.referals;
        this.$root.$emit('refresh:history');
        this.$toastr.success(this.$i18n.t('client.client_refered_successfull'),this.$i18n.t('client.client_refered_successfull'));
      });
    },
    openContactModal(){
      this.messageModal = true;
    },
    contact(){
      var vm = this;
      if(!this.message){
        this.$toastr.error("Please insert message");
        return;
      }

      let body={
        message : this.message,
        specialist: this.selectedSpecialist.id,
      };

      SpecialistService.sendContact(body).then((res)=>{
        if(res.data.success){
          vm.$toastr.success("Specialist contacted successfully, you will be contacted through your email soon");
          this.message = "";
        }else{
          vm.$toastr.error(res.data.message);
        }
      })
    }
  },
  computed: {
    language() {
        return this.$store.getters['UserModules/getLanguage']
    },

    clients() {
      let cli = Models.Client.all();
      let options = [];
      for (let i in cli) {
        let repr = cli[i].id + ' ' + cli[i].first_name + ' ' + cli[i].last_name
        var d = new Object()
        d.text = repr
        d.value = cli[i].id
        options.push(repr)
      }
      return options;
    },
  },
  filters : {
    getCommission : function(specialist){
      if(!!specialist.commissions){
        return ((specialist.commissions/2)*specialist.cost)/100 +' ₪';
      }else if(!!specialist.amount){
        return (specialist.amount/2)+' ₪';
      }
      return '0 ₪';
    }
  }
}
</script>
